import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from "rxjs";
import {UserSubscription} from "../../../../../../../../user/user-subscription";
import {ChosenPlan} from "../../../../../../payment-info/models/plan.model";
import {GoogleAnalyticsService} from "../../../../../../../services/google-analytics/google-analytics.service";
import {OneMonthFreeStep} from "../../../../one-month-free.component";
import {TextUtils} from "../../../../../../../utils/text-utils";
import {Utils} from "../../../../../../../utils/utils";


@Component({
    selector: 'db-one-week-free-demo-ecommerce-option',
    templateUrl: './one-week-free-demo-ecommerce-option.component.html',
    styleUrls: ['./one-week-free-demo-ecommerce-option.component.scss'],
    standalone: false
})
export class OneWeekFreeDemoEcommerceOptionComponent implements OnInit, OnDestroy {
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  monthlyPrice: number;
  isMobile: boolean;
  @Output() onPlanChange = new EventEmitter<ChosenPlan>();
  @Output() onStepChange = new EventEmitter<OneMonthFreeStep>();

  @Input() isAgency: boolean = false;
  @Input() mostPopular: boolean = false;
  @Input() paidFeature?: boolean = false;
  @Input() title: string;
  @Input() domainName?: string;
  @Input() activeTab: string;
  @Input() description: string = null;
  @Input() planDesc: string = null;
  @Input() plan: string[];
  @Input() subscription: UserSubscription;
  @Input() periodSwitchValue: number = 12;
  @Input() professionalInfo: boolean;
  @Input() applyCouponForPlatform?: boolean;
  @Input() couponPercent?:  number = 0;
  @Input() hasFreeDays: boolean = false;
  @Input() customDomainFlow?: boolean;
  @Input() availableSubscriptions?: any;

  constructor(
    private _googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit() {
    if ((Utils.checkDevice() && window.innerWidth <= 1024)) {
      this.isMobile = true;
    }
    const monthlySubscription = this.availableSubscriptions.find(userSubscription =>
      userSubscription && this.subscription && userSubscription.category && userSubscription.category === this.subscription.category
      && userSubscription.tabCategory && userSubscription.tabCategory === this.subscription.tabCategory
      && userSubscription.plan && userSubscription.plan.periodNumber && userSubscription.plan.periodNumber === 1
    );
    this.monthlyPrice = monthlySubscription && monthlySubscription.plan && monthlySubscription.plan.planPrice;
  }

  public replaceParam(string, params: any = null): string {
    return TextUtils.getText(null, params, string);
  }

  public chooseSubscr(subscription: UserSubscription) {
    const chosenPlan: ChosenPlan = {
      id: subscription.id,
      title: subscription.plan.title,
      price: subscription.plan.planPrice,
      type: this.periodSwitchValue === 12 ? 'year' : 'month'
    };
    this.onPlanChange.emit(chosenPlan);
    this._sendEvent(chosenPlan);
  }

  private _sendEvent(chosenPlan): void {
    const analyticsData = {
      eventCategory: 'Dashboard Pageview',
      eventAction: 'Checkout Page visit (1wf pop-up)',
      eventLabel: chosenPlan.title + ' ' + chosenPlan.type + 'ly'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }
}
